import { apiClient } from "./api";

export const dashboardService = {
  summary: () => apiClient.get("/dashboard/summary").then((r) => r.data),
  trends: () => apiClient.get("/dashboard/trends").then((r) => r.data),
  activity: (limit = 8) =>
    apiClient.get("/dashboard/activity", { params: { limit } }).then((r) => r.data),
};
